import "./searchTermReporting.scss";
import React, { useEffect, useRef, useState } from "react";
import DefaultLayout from "../../layout/defaultLayout";
import { Box, Chip, Snackbar, Alert } from "@mui/material";
import { DatePicker } from "components/DatePicker/index";
import { useDispatch, useSelector } from "react-redux";
import {
  updateLevel,
  updateHotelId,
  updateGroupId,
} from "store/slices/account/accountSlice";
import HotelsFilterMenu from "components/hotelFilterMenu";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import EditCampaignPanel from "features/google-search-ads-campaign/EditCampaignPanel";
import PageTitles from "../../components/PageTitles";
import SearchTermChartContainer from "features/searchads/searchTermReporting/chartContainer";
import SearchTermTableContainer from "features/searchads/searchTermReporting/TableContainer";
import HoverButton from "../../components/HoverButton";
import qs from 'query-string';
import { updateSearchTermReportingSegmentList, updateSearchTermReportingSelectedSegments } from "store/slices/searchAds/searchAds";
import { getDefaultSegments } from "utils/functions/getDefaultSegments";

const SearchTermReportingPage = () => {
  const searchParams = qs.parse(window.location.search)
  const {pathname, search} = useLocation()
  const {platform,selected_segments} = useSelector((state) => state?.searchAds);
    const hotelId = useSelector((state) => state?.account?.hotel_id);
    const {
        account_id = "",
        "is_account_writable": isAccountWritable,
    } = useSelector((state) => state?.account?.account || {});
  const {hotelList = [], groupList = []} = useSelector(state => state?.account)
  const hotelButtonRef = useRef(null);
  const [openHotelModal, setOpenHotelModal] = useState(false);
  const [hotelFilters, setHotelFilters] = useState([]);
  const [selectedHotelOrGroupType, setSelectedHotelOrGroupType] =
    useState("hotels");
  const scrollContainerRef = useRef(null);
  const [isChartCollapsed, setIsChartCollapsed] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isPanelOpen, setPanelOpen] = useState(false);
  const [editCampaignId, setEditCampaignId] = useState();
  const [,setCurrentAccountId] = useState(account_id);
  

  const handleCreateCampaign = () => {
    if (hotelFilters.length ===1) {
      navigate(`/search-ads-campaign/create/${account_id}/${hotelId?.[0]}`);
    } else {
      setToastMessage("Please select one hotel.");
      setToastType("error");
      setShowToast(true);
    }
  };

  const togglePanel = () => {
    setPanelOpen((prev) => !prev);
  };

  useEffect(() => {
            if(account_id){
              setCurrentAccountId(prev => {
                if(prev !== account_id){
                  dispatch(updateGroupId([]));
                }
                return account_id;
              })
            }else {
              if (searchParams?.["hotelid"]) {
                dispatch(updateLevel("HOTEL"));
                if (typeof searchParams?.["hotelid"] === "string") {
                  dispatch(updateHotelId([Number(searchParams?.["hotelid"])]));
                } else {
                  dispatch(
                    updateHotelId(
                      searchParams?.["hotelid"].map((h) => Number(h))
                    )
                  );
                }
              }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
          }, [account_id, hotelList, dispatch, search]);

  useEffect(() => {
    dispatch(
      updateLevel(selectedHotelOrGroupType === "hotels" ? "HOTEL" : "GROUP")
    );

    if(!searchParams?.['segments']){
     if (searchParams?.["hotelid"]) {
          dispatch(updateLevel("HOTEL"));
          if (typeof searchParams?.["hotelid"] === "string") {
            dispatch(updateHotelId([Number(searchParams?.["hotelid"])]));
            dispatch(
              updateSearchTermReportingSegmentList(
                getDefaultSegments([Number(searchParams?.["hotelid"])])
              )
            );
          } else {
            dispatch(
              updateHotelId(searchParams?.["hotelid"].map((h) => Number(h)))
            );
            dispatch(
              updateSearchTermReportingSegmentList(
                getDefaultSegments(searchParams?.["hotelid"].map((h) => Number(h)))
              )
            );
          }
        } 
        dispatch(updateSearchTermReportingSelectedSegments(null))
    } else {
      dispatch(updateSearchTermReportingSelectedSegments(typeof searchParams?.['segments']=== 'string' ? [searchParams?.['segments']]: searchParams?.['segments']))
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch,search,hotelList]);

  useEffect(() => {
      if(!searchParams?.['hotelid'] && !searchParams?.['segments']){
        dispatch(updateSearchTermReportingSegmentList(getDefaultSegments(hotelId)))
      }
    },[dispatch,search,hotelId])

  useEffect(() => {
    return () => {
       if(!searchParams?.['segments']) {
      dispatch(updateSearchTermReportingSelectedSegments(null));
       }
    };
  }, [dispatch]);

  return (
    <div className="metasearch">
      <DefaultLayout page={isPanelOpen ? null : "SearchAdsPage"}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginRight: "18px",
          }}
        >
          <PageTitles
            pageTitle="Search Ads"
            pageSubTitle="Search Terms"
          />
            <div
            style={{
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "8px",
            }}
          >
            {isAccountWritable &&(
                <HoverButton text="New Campaign" onClick={handleCreateCampaign}/>
             )}
            <DatePicker />
          </div>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingInline: 2,
          }}
        >
          <div>
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#000000",
                  fontWeight: "400",
                  marginTop: "4px",
                }}
              >
                <div
                  onClick={() => {
                    setOpenHotelModal(true);
                  }}
                  ref={hotelButtonRef}
                >
                  <Chip
                    label={
                      hotelId.length === 0
                        ? "Hotels"
                        : (selectedHotelOrGroupType === "hotels" &&
                            hotelId.length === hotelList.length) ||
                          (selectedHotelOrGroupType === "groups" &&
                            hotelId.length === groupList.length)
                        ? selectedHotelOrGroupType === "hotels"
                          ? "All Hotels"
                          : "All Groups"
                        : hotelId.length === 1
                        ? hotelList?.find(
                            (hotel) =>
                              hotel.hotel_id === hotelId?.[0]
                          )?.hotel_name
                        : `${hotelId.length} ${
                            selectedHotelOrGroupType === "hotels"
                              ? "hotels"
                              : "groups"
                          } selected`
                    }
                    sx={{
                      backgroundColor:"inherit",
                      fontFamily: "inter",
                      fontSize: "12px",
                      fontWeight: "400",
                      marginRight: "4px",
                      cursor: "pointer",
                      height: "26px",
                      minWidth:'120px',
                      border:"1px solid #BAB7B7",
                        ":hover": {
                            cursor: "pointer",
                            border: "1px solid #000000",
                        },
                    }}
                  />
                </div>
                {openHotelModal && (
                  <HotelsFilterMenu
                    allHotels={hotelList?.map((ho) =>
                      hotelId.find((hf) => hf === ho.hotel_id)
                        ? { ...ho, isSelected: true }
                        : { ...ho, isSelected: false }
                    )}
                    showGroups={false}
                    anchorEl={hotelButtonRef.current}
                    open={openHotelModal}
                    isSelectAllRequired
                    onApply={(selected) => {
                        setHotelFilters(selected);
                        if (selectedHotelOrGroupType === "hotels") {
                          if(!selected_segments){
                          if (selected.length === 1) {
                            dispatch(
                              updateSearchTermReportingSegmentList(["CAMPAIGN"])
                            );
                            dispatch(updateSearchTermReportingSelectedSegments(null))
                          } else {
                            dispatch(
                              updateSearchTermReportingSegmentList(["HOTELS"])
                            );
                            dispatch(updateSearchTermReportingSelectedSegments(null))
                          }
                        }
                          dispatch(
                            updateHotelId(
                              selected.map((item) => item?.["hotel_id"])
                            )
                          );
                        } else {
                          dispatch(
                            updateGroupId(selected.map((item) => item?.["id"]))
                          );
                        }
                      navigate(`${pathname}?${createSearchParams({hotelid: selected?.map(p => p.hotel_id),segments: searchParams?.['segments']})}`)
                    }}
                    onClose={() => {
                      setOpenHotelModal(false);
                    }}
                    setSelectedHotelOrGroupType={(type) => {
                      setSelectedHotelOrGroupType(type);
                      dispatch(
                        updateLevel(type === "hotels" ? "HOTEL" : "GROUP")
                      );
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </Box>
        <Box sx={{}} ref={scrollContainerRef}>
          <div
            style={{
              display: isChartCollapsed ? "none" : "block",
            }}
          >
            <SearchTermChartContainer backgroundColor="transparent" />
          </div>
          <SearchTermTableContainer
            isChartCollapsed={isChartCollapsed}
            setIsChartCollapsed={setIsChartCollapsed}
            onEditClick={() => {
              if (platform?.length > 1) {
                setToastMessage("Please select single platform");
                setToastType("error");
                setShowToast(true);
              }
            }}
            onEditCampaign={(id) => {
              setEditCampaignId(id);
              setPanelOpen(true);
            }}
          />
        </Box>{" "}
        <EditCampaignPanel campaignId={editCampaignId} isOpen={isPanelOpen} onClose={togglePanel} />
      </DefaultLayout>
      <Snackbar
        // anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={showToast}
        autoHideDuration={3000}
        onClose={() => {
          setShowToast(false);
        }}
      >
        <Alert severity={toastType} variant="filled" sx={{ width: "100%" }}>
          {toastMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default SearchTermReportingPage;
